import { Component, OnInit, HostListener, EventEmitter   }    from '@angular/core';
import { Router, ActivatedRoute }               from '@angular/router';
import { TranslateService }                     from '@ngx-translate/core';
import { UserService }                          from './_service/user.service';
import { InterfaceService }                     from './_service/interface.service';
import { BackendService }                       from './_service/backend.service';
import { ResizeService }                        from './_service/resize-service';
// import * as angular_constants                   from "../../angular.json";
import { EventEmitterService }                  from './_service/event-emitter.service';
import { Constants }                            from './models/Constants';
import { UtilityService } from './_service/utility.service';
import { LocalStorageService } from './_service/local-storage.service';
import { ZimbraInstanceService } from './_service/zimbrainstance.service';

@Component({
  providers     : [ UserService ],
  selector      : 'app-root',
  templateUrl   : './app.component.html',
  styleUrls     : ['./app.component.css']
})

export class AppComponent implements OnInit{

  public check_diff_sub = null;
  text_color            = "black";
  server_error          = false;
  project_labels        = "";

  classic_login         : boolean = true;

  dark_mode             : boolean = false;
  settings              : Object;

  login_selected        : string = null;

  user_migrating        : boolean = false;

  constructor(
                private _router            : Router,
                private _userService       : UserService,
                private _translateService  : TranslateService,
                private _interfaceService  : InterfaceService,
                private _backendService    : BackendService,
                private _eventEmitterService    : EventEmitterService,
       	        private _resizeService     : ResizeService,
                private _zimbraInstanceService : ZimbraInstanceService,
                private _localStorageService: LocalStorageService,
                private _route              : ActivatedRoute
              ) 
  { 
        this._translateService.addLangs(['en', 'it']);
        this._translateService.setDefaultLang('it');
        this._translateService.use('it');
        // var all_keys = Object.keys(angular_constants.projects);
        // this.project_labels = all_keys[0];
        this.project_labels = Constants.PROJECT_LABEL;
    }

    //Switch language
    switchLanguage(language: string) {
        this._translateService.use(language);
    }

    ngOnInit() 
    {
        this._route.queryParams
            .subscribe(params => {
                console.log(params); // { orderby: "price" }

                //NOTA: Non impostate di default il login_selected perche' angular scatena le sue cose
                //e rischiate che su PC lenti si veda prima la login di AUSL e poi quella admin
                if (!UtilityService.empty(params["path"]))
                {
                    if (params["path"] === "adminlogin")
                    {
                        this.login_selected = "ADMIN";        
                    }
                    else if (params["path"] === "forcelogout")
                    {
                        // localStorage.removeItem(this.project_labels + '_user_info');
                        // sessionStorage.clear();
                        // window.location.href = "/authportal/ui";
                        this.logout();
                    }
                    else
                    {
                        this.login_selected = Constants.getSettingValue("login_selected");
                    }
                }
                else
                {
                    this.login_selected = Constants.getSettingValue("login_selected");
                }

                // if (this.login_selected === undefined)
                // {
                //     this.loading = true;
                //     this.ngOnInit();
                // }
            }
        );

        // this._route.snapshot.paramMap.get('id');

        this.dark_mode = localStorage.getItem(this.project_labels + "_dark_mode") ? UtilityService.getBoolean(localStorage.getItem(this.project_labels + "_dark_mode")) : false;

        //Side Menu Event
        this._eventEmitterService.addEventEmitter("side_menu");
        this._eventEmitterService.addEventEmitter("side_menu_updated");

        this.initializeSystem();
        this.checkCurrentSize();

        this._eventEmitterService.addEventEmitter("dark_mode");
        
        this._eventEmitterService.getEventEmitter("dark_mode").subscribe(function(value) {
            this.dark_mode = JSON.parse(value);
            this._localStorageService.setWatchedLocalStorage(this.project_labels + '_dark_mode', this.dark_mode);
        }.bind(this));



    }

    initializeSystem() {
        if (!this._userService.isLogged()) 
        {
            this._backendService.getSoftwareSettings().subscribe(
                data => {
                    var localstorage_key = this.project_labels + "_software_settings";
                    this.classic_login = data["classic_login"];
                    localStorage.setItem(localstorage_key, JSON.stringify(data));
                    var login_selected = Constants.getSettingValue("login_selected");
                    if (this.login_selected !== "ADMIN")
                    {
                        this.login_selected = login_selected;
                    }
                },
                err => {
                    let error_message = err.message !== undefined ? err.message : err.error;
                    // this._interfaceService.openSimpleErrorSnackBar(error_message, false);
                    this.server_error = true;
                    this._router.navigate(["/serror/"]);
                },
            );

            this._userService.getUserInfo().subscribe(
                data => {
                    this._userService.storeUserData(data["retdata"]["data"]);
                    this.ngOnInit();
                    // this._router.navigate([ 'dashboard' ]);
                },
                err => {
                    this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
                })
        }
        else
        {
            var auto_login_zimbra = this.getSettingValue("auto_login_zimbra");
            if (auto_login_zimbra)
            {
                this.zimbraLogin();
            }
        }
        
    }

    isSerror() {
        return this.server_error;
    }

    public isLogged(): boolean {
        return this._userService.isLogged();
    }

    @HostListener('window:resize', ['$event'])
    public onResize(event?) {
        var screenWidth = event.target.innerWidth;
        var screenState = this._resizeService.calcCurrentScreenState(screenWidth);
        this._resizeService.onResize(screenState);
    }

    checkCurrentSize() {
        var screenState = this._resizeService.checkCurrentSize();
        this._resizeService.onResize(screenState);
    }

    //Try to get the settings from LocalStorage.
    //If not exists, It try to access the default settings that is in window variables set by backend with frontend_settings.js
    getSettingValue(label) 
    {
        return Constants.getSettingValue(label);

        // this.settings = localStorage.getItem(this.project_labels + "_software_settings") !== null ? JSON.parse(localStorage.getItem(this.project_labels + "_software_settings")) : null;
        // if (this.settings !== null && this.settings[label] !== null) {
        //     return this.settings[label]
        // }
        // else 
        // {
        //     var default_settings = Constants.DEFAULT_SETTINGS;
        //     if (default_settings !== null && default_settings[label] !== null) 
        //     {
        //         return default_settings[ label ];
        //     }
        //     return undefined;
        // }
    }

    zimbraLogin()
    {
        this.user_migrating = false;
        this._zimbraInstanceService.zimbraLogin().subscribe(
            data => 
            {
                var ass = data["retdata"]["data"];
                if (ass === "zimbrainstance.no_association")
                {
                    this.user_migrating = true;
                }
                else
                {
                    var  redirect_parameter_url = "";
                    var final_redirect_url = data["retdata"]["data"];
                    window.open(final_redirect_url, "_self");
                }
                
            },
            err => {
                this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
            })
    }

    logout()
    {
        this._userService.logout().subscribe(
        data => {
            localStorage.removeItem(this.project_labels + '_user_info');
            sessionStorage.clear();
            var return_homepage = this.getSettingValue("return_homepage");
            window.location.href = return_homepage;
        },
        error => {
            localStorage.removeItem(this.project_labels + '_user_info');
            sessionStorage.clear();
            var return_homepage = this.getSettingValue("return_homepage");
            window.location.href = return_homepage;
            // window.location.HREF = "/authportal/ui";
            // this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        });

        // this._userService.logout();
        // this._userService.oidcLogout();
        // this._router.navigate(['']);
    }

}
